import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Form,
  Grid,
  theme,
  Alert,
  Radio,
  Space,
  ConfigProvider,
  Modal,
  message,
  Select,
  Spin,
  Input,
  InputNumber,
} from "antd";
import { Col, Row } from "antd";
import useToasterMessage from "helpers/useToasterMessage";
import { useUiState } from "helpers/useUiState";
import { useNavigate } from "react-router-dom";
import {} from "antd";
import i18n from "i18next";
import { clearLocalStore } from "helpers/localStoreSrv";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";
import BrandColors from "@brand-colors";
import { useAddressVerificationSrv } from "./useAddressVerificationSrv";
import ReactGA from "react-ga";
import { t } from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";
import { Home, Building2, MapPin, Building, Flag, Mail } from "lucide-react";
import "./AddressVerification.css";
const { useToken } = theme;
const { useBreakpoint } = Grid;
type SizeType = Parameters<typeof Form>[0]["size"];

const AddressVerification = ({
  onDataFromChild,
  memberData,
  addressEnabled,
}: any) => {
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default",
  );
  const { token } = useToken();
  const screens = useBreakpoint();
  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };
  const [addressData, setAdressData] = useState([]);
  const [choices, setChoices] = useState("Other");
  const [pinResetKey, setPinResetKey] = useState(0);
  const [showSaveButton, setshowSaveButton] = useState(1);
  const { isAppLoading } = useUiState();
  const [memberAddress, setMemberAddress] = useState({});
  const [additionalAddresses, setAdditionalAddresses] = useState([]);
  const [showAdditionalAddresses, setShowAdditionalAddresses] = useState(false);
  const alertRef = useRef<HTMLDivElement>(null);
  const successAlertRef = useRef<HTMLDivElement>(null);
  const [formData, setFormData] = useState({
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressCity: "",
    AddressState: "",
    AddressPostalCode: "",
  });

  useEffect(() => {
    if (memberData) {
      setFormData({
        AddressLine1: memberData.AddressLine1 || "",
        AddressLine2: memberData.AddressLine2 || "",
        AddressLine3: memberData.AddressLine3 || "",
        AddressCity: memberData.AddressCity || "",
        AddressState: normalizeStateValue(memberData.AddressState) || "",
        AddressPostalCode: memberData.AddressPostalCode || "",
      });
    }
  }, [memberData]);
  const [formModalData, setFormModalData] = useState({
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressCity: "",
    AddressState: "",
    AddressPostalCode: "",
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailureMessage, setShowFailureMessage] = useState("");
  const [validationError, setValidationError] = useState(null);
  const uiState = useSelector((state: any) => state.portal.uiState);
  const [modalValidationError, setModalValidationError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validateSyncAddress, setValidateSyncAddress] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const location = useLocation();
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language,
  );
  const [successMessage, setSuccessMessage] = useState("");

  const [currentLanguage, setCurrentLanguage] = useState(preferredLanguage);
  const [isRightAlign, setIsRightAlign] = useState(false);
  const [isAddressEditable, setIsAddressEditable] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const [stateSuccessDropdownOpen, setStateSuccessDropdownOpen] =
    useState(false);
  const { logSessionDetail } = useSessionDetailLog();

  const US_STATES = [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" },
  ];

  const normalizeStateValue = (stateValue: any): string => {
    if (!stateValue) return "";

    const stateStr = String(stateValue).trim();

    if (stateStr.length === 2) {
      const upperCaseAbbr = stateStr.toUpperCase();
      const foundState = US_STATES.find(
        (state) => state.value === upperCaseAbbr,
      );
      if (foundState) return foundState.value;
    }

    const foundState = US_STATES.find(
      (state) => state.label.toLowerCase() === stateStr.toLowerCase(),
    );

    return foundState ? foundState.value : "";
  };

  const validateAddress = (data: any) => {
    const schema = {
      AddressLine1: function (value: any) {
        return (
          !!value &&
          /^[^-\s][a-zA-Z0-9_\s-.'-]{3,}$/.test(value) &&
          value.length > 3
        );
      },
      AddressLine2: function (value: any) {
        return (
          !!value &&
          /^[^-\s][a-zA-Z0-9\s.,#$]+$/.test(value) &&
          value.length > 2
        );
      },
      AddressCity: function (value: any) {
        return !!value && /^[^-\s][A-Za-z ]+$/.test(value) && value.length >= 2;
      },
      AddressState: function (value: any) {
        return !!value && /^[^-\s][A-Za-z ]+$/.test(value) && value.length >= 2;
      },
      AddressPostalCode: function (value: any) {
        return !!value && /^\d{5}([\-]?\d{4})?$/.test(value);
      },
    };

    const validate = (object: any, schema: any) =>
      Object.keys(schema)
        .filter((key) => !schema[key](object[key]))
        .map((key) => {
          if (key == "AddressLine1") {
            return `${t("PROFILE_PAGE.ADDRESS_LINE_1_ERROR")}.`;
          } else if (key == "AddressLine2") {
            return `${t("PROFILE_PAGE.ADDRESS_LINE_2_ERROR")}.`;
          } else if (key == "AddressCity") {
            return `${t("PROFILE_PAGE.CITY_ERROR")}.`;
          } else if (key == "AddressState") {
            return `${t("PROFILE_PAGE.STATE_ERROR")}.`;
          } else if (key == "AddressPostalCode") {
            return `${t("PROFILE_PAGE.PIN_ERROR")}.`;
          }
          return `${key} is invalid.`;
        });
    console.log(schema, "schema");
    const errors = validate(data, schema);

    if (errors.length > 0) {
      setValidationError(errors[0]);
      return false;
    } else {
      setValidationError("");
      return true;
    }
  };

  const handleInputChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const clearForm = () => {
    setFormData({
      AddressLine1: "",
      AddressLine2: "",
      AddressLine3: "",
      AddressCity: "",
      AddressState: "",
      AddressPostalCode: "",
    });
    setPinResetKey((prevKey) => prevKey + 1);
    setValidationError("");
  };
  const handleSubmit = async () => {
    setCurrentLanguage(preferredLanguage);
    const isValid = validateAddress(formData);
    if (isValid) {
      if (choices === "MemberAddress") {
        const addrObj = {
          AddressDetails: formData,
          RequireApproval: false,
        };
        let result: any;
        setSubmitting(true);
        try {
          result = await submitMemberAddresses(addrObj);
        } catch (error) {
          handleErrorNavigation(error, navigate, t);
          message.error(
            t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
              "Something went wrong",
          );
          UseToaster({
            type: "error",
            message:
              t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
              "Something went wrong",
          });
        } finally {
          setSubmitting(false);
        }

        if (result && result.data && result.data.ResponseStatus === 0) {
          setIsModalOpen(false);
          setIsAddressEditable(false);
          setValidationError("");
          ReactGA.event({
            category: "Save Button Click ",
            action: "Address Updated Successfully",
            label: "ThankYou Address Verification Page",
          });

          onDataFromChild(result.data.ResponseMessage);
          setshowSaveButton(0);
        } else {
          message.error(t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"));
          UseToaster({
            type: "error",
            message: t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"),
          });

          ReactGA.event({
            category: "Save Button Click ",
            action: "Address Updated Unsuccessfully",
            label: "ThankYou Address Verification Page",
          });
        }
      } else {
        let result: any;
        setSubmitting(true);
        try {
          result = await submitValidateAddresses(formData);
          if (result.data.AddressStatus === 1) {
            setValidateSyncAddress(result.data);
            setIsModalOpen(true);
          } else {
            setIsModalOpen(false);
            setShowSuccess(true);
            message.error(t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"));
            UseToaster({
              type: "error",
              message: t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"),
            });

            ReactGA.event({
              category: "Save Button Click ",
              action: "Address Updated Unsuccessfully",
              label: "ThankYou Address Verification Page",
            });
          }
        } catch (error) {
          handleErrorNavigation(error, navigate, t);
          message.error(
            t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
              "Something went wrong",
          );
          UseToaster({
            type: "error",
            message:
              t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
              "Something went wrong",
          });
        } finally {
          setSubmitting(false);
        }
      }
    }
  };
  const proceedToUpdate = () => {
    handleSubmit();
  };
  const confirm = async () => {
    const isValid = validateAddress(formData);
    if (isValid) {
      const msg = t("PROFILE_PAGE.SAVED_SUCCESSFULLY") || "Saved successfully";
      message.success(msg);
      UseToaster({ type: "success", message: msg });
      setSuccessMessage(msg);
    }
  };

  const { getMemberAddresses, submitMemberAddresses, submitValidateAddresses } =
    useAddressVerificationSrv();
  const navigate = useNavigate();
  const { UseToaster } = useToasterMessage();

  const styles = {
    container: {
      margin: "0 auto",
      padding: screens.md
        ? `${token.paddingXL}px`
        : `${token.sizeXXL}px ${token.padding}px`,
      width: "380px",
    },
    footer: {
      marginTop: token.marginLG,
      textAlign: "center",
      width: "100%",
    },
    forgotPassword: {
      float: "right",
    },
    header: {},
    section: {
      alignItems: "center",
      backgroundColor: token.colorBgContainer,
      display: "flex",
      padding: screens.md ? `0px 0px` : "0px",
      textAlign: "left",
    },
    text: {
      color: token.colorTextSecondary,
    },
    title: {
      fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3,
    },
    button: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "100%",
      marginTop: "15px",
      fontWeight: "bold",
    },
    upload: {
      display: "flex",
      background: "#f00",
    },
    subheader: {
      fontWeight: "600",
      width: "100%",
    },
    addressHeader: {
      fontWeight: "600",
      width: "100%",
      color: "#333333",
      textAlign: isRightAlign ? "right" : "left",
      display: "block",
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      maxWidth: "420px",
      marginLeft: "25px",
    },
    buttonClear: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "auto",
      marginTop: "15px",
      fontWeight: "bold",
      marginRight: "10px",
    },
    buttonSave: {
      backgroundColor: BrandColors.BUTTON_BG,
      borderRadius: "50px",
      width: "auto",
      marginTop: "15px",
      fontWeight: "bold",
    },
    formSec: {
      marginTop: "15px",
      marginLeft: "25px",
    },
    successAlert: {
      margin: 0,
      color: BrandColors.HEADER_BG,
      textAlign: isRightAlign ? "right" : "left",
    },
  };

  const onChangeValue = (event: any) => {
    const value = event.target.value;
    const parts = value.split("+");
    if (value === "MemberAddress") {
      const selected = addressData[value];
      setFormData(selected);
    } else if (value === "Other") {
      clearForm();
    } else {
      const firstPart = parts[0];
      const secondPart = Number(parts[1]);
      setFormData(addressData[firstPart][secondPart]);
    }

    setChoices(event.target.value);
    console.log(event.target.value);
  };

  const onChangeModalValue = (event: any) => {
    const value = event.target.value;
    const selected = validateSyncAddress[value];
    setFormModalData(selected);
    setSelectedValue(event.target.value);
  };
  useEffect(() => {
    if (validationError && alertRef.current) {
      alertRef.current.focus();
    }
  }, [validationError]);

  useEffect(() => {
    if (successMessage && successAlertRef.current) {
      successAlertRef.current.focus();
    }
  }, [successMessage]);
  useEffect(() => {
    console.log("uiState.Language", uiState.Language);
    i18n.changeLanguage(uiState.Language);
  }, []);
  useEffect(() => {
    const applyAriaRequired = (id: string) => {
      const input = document.getElementById(id);
      if (input && input.tagName === "INPUT") {
        input.setAttribute("aria-required", "true");
      }
    };
    applyAriaRequired("address-state");
    applyAriaRequired("address-state-success");
  });
  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          preferredLanguage,
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
      message.error(
        t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
          "Something went wrong",
      );
      UseToaster({
        type: "error",
        message:
          t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
          "Something went wrong",
      });
    }
  }, [preferredLanguage, whitelabelConfig, currentLanguage]);
  useEffect(() => {
    getMemberAddresses()
      ?.then((res) => {
        isAppLoading(false);
        (async () => {
          setAdressData(res.data);
          setMemberAddress(res.data.MemberAddress);
          const additionalAddressesData = res.data.AdditionalAddresses;
          setAdditionalAddresses(additionalAddressesData);
          logSessionDetail("AddressPageViewed");
        })();
      })
      .catch((e) => {
        isAppLoading(false);
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
        message.error(
          t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
            "Something went wrong",
        );
        UseToaster({
          type: "error",
          message:
            t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
            "Something went wrong",
        });
      });
  }, []);
  const getSelectedStateLabel = (stateCode: string) => {
    const found = US_STATES.find((s) => s.value === stateCode);
    return found ? found.label : "";
  };
  const handleModelOk = async () => {
    const addrObj = {
      AddressDetails: formModalData,
      RequireApproval: false,
    };

    if (selectedValue) {
      let result: any;
      setSubmitting(true);
      try {
        result = await submitMemberAddresses(addrObj);
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
        message.error(
          t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
            "Something went wrong",
        );
        UseToaster({
          type: "error",
          message:
            t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL") ||
            "Something went wrong",
        });
      } finally {
        setSubmitting(false);
      }
      if (result && result.data && result.data.ResponseStatus === 0) {
        setIsModalOpen(false);
        setIsAddressEditable(false);
        setValidateSyncAddress(null);
        setSelectedValue(null);
        setModalValidationError(null);
        setValidationError("");
        ReactGA.event({
          category: "Save Button Click ",
          action: "Address Updated Successfully",
          label: "ThankYou Address Verification Page",
        });

        onDataFromChild(result.data.ResponseMessage);
        setshowSaveButton(0);
      } else {
        message.error(t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"));
        UseToaster({
          type: "error",
          message: t("PROFILE_PAGE.ADDRESS_UPDATED_UNSUCCESSFULL"),
        });

        ReactGA.event({
          category: "Save Button Click ",
          action: "Address Updated Unsuccessfully",
          label: "ThankYou Address Verification Page",
        });
      }
    } else {
      setModalValidationError("Please select an address.");
      message.error("Please select an address.");
      UseToaster({ type: "error", message: "Please select an address." });
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <section style={styles.section}>
      <Spin spinning={submitting}>
        <div style={{ width: "100%", padding: "15px" }}>
          {!showSuccess ? (
            <div style={styles.header}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: BrandColors.HEADER_BG
                      ? BrandColors.HEADER_BG
                      : "#1677ff",
                    fontFamily: "Montserrat, sans-serif",
                  },
                }}
              >
                {location.pathname == "/thankyou" ? (
                  <>
                    <div
                      style={{
                        fontSize: "16px",
                        marginBottom: "10px",
                        fontWeight: "bold",
                        color: BrandColors.HEADER_BG,
                      }}
                    >
                      {t("PROFILE_PAGE.MEMEBERADDR_ADDR")}
                    </div>
                    <Radio.Group
                      onChange={onChangeValue}
                      value={choices}
                      // name="MemberAddress"
                      data-testid="test-address-radiogroup"
                    >
                      <Space direction="vertical">
                        <Radio
                          value={"MemberAddress"}
                          data-testid="test-addressmember-radio"
                        >
                          <div style={styles.subheader}>
                            <div>
                              {memberAddress.AddressLine1}
                              {memberAddress.AddressLine2}
                              {memberAddress.AddressLine3}
                            </div>
                            <div>{memberAddress.AddressCity}</div>
                            <div>
                              {memberAddress.AddressState}
                              {memberAddress.AddressPostalCode}
                            </div>
                          </div>
                        </Radio>
                        <Radio
                          value={"Other"}
                          data-testid="test-addressother-radio"
                        >
                          <div style={styles.subheader}>
                            {" "}
                            {t("PROFILE_PAGE.OTHERS")}
                          </div>
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </>
                ) : null}
              </ConfigProvider>

              {choices == "Other" ? (
                <div
                  style={styles.formSec}
                  className="address-form-section address-form-stacked"
                >
                  <Row gutter={[16, 4]}>
                    <Col span={24}>
                      <label
                        id="address-line1-label"
                        role="article"
                        aria-label="address-line1-label"
                        tabIndex={0}
                        htmlFor="address-line1"
                        style={styles.addressHeader}
                      >
                        {t("PROFILE_PAGE.ADDRESS_LINE_1")}
                        <span
                          className="required-asterisk"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only"> required</span>
                      </label>
                      <div className="field-with-icon">
                        {/* <Home className="field-icon" size={18} role="img" aria-label="address-line1-icon" id="home-icon" tabIndex={0} aria-hidden="false" /> */}
                        <Home
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          role="img"
                          aria-label="Home icon"
                          tabIndex={0}
                        />
                        <Input
                          id="address-line1"
                          autoComplete="address-line1"                          
                          aria-required="true"
                          value={formData.AddressLine1}
                          aria-disabled={!isAddressEditable}
                          readOnly={!isAddressEditable}
                          className={
                            !isAddressEditable ? "address-input-readonly" : ""
                          }
                          // disabled={!isAddressEditable}
                          onChange={(e: any) =>
                            handleInputChange("AddressLine1", e.target.value)
                          }
                        />                                           
                      </div>
                    </Col>
                    <Col span={24}>
                      <label
                        id="address-line2-label"
                        tabIndex={0}
                        role="article"
                        aria-label="address-line2-label"
                        htmlFor="address-line2"
                        style={styles.addressHeader}
                      >
                        {t("PROFILE_PAGE.ADDRESS_LINE_2")}
                        <span
                          className="required-asterisk"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only"> required</span>
                      </label>
                      <div className="field-with-icon">
                        <Building2
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          id="build-icon"
                          role="img"
                          aria-label="address-line2-icon"
                          tabIndex={0}
                        />
                        <Input
                          id="address-line2"
                          //aria-label="Address Line 2"
                          autoComplete="address-line2"
                          aria-required="true"
                          value={formData.AddressLine2}
                          aria-disabled={!isAddressEditable}
                          readOnly={!isAddressEditable}
                          className={
                            !isAddressEditable ? "address-input-readonly" : ""
                          }
                          // disabled={!isAddressEditable}
                          onChange={(e: any) =>
                            handleInputChange("AddressLine2", e.target.value)
                          }
                        />
                      </div>
                    </Col>
                    <Col span={24}>
                      <label
                        id="address-line3-label"
                        tabIndex={0}
                        role="article"
                        aria-label="address-line3-label"
                        htmlFor="address-line3"
                        style={styles.addressHeader}
                      >
                        {t("PROFILE_PAGE.ADDRESS_LINE_3")}
                      </label>
                      <div className="field-with-icon">
                        <MapPin
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          id="map-icon"
                          tabIndex={0}
                          role="img"
                          aria-label="address-line3-icon"
                          aria-hidden="false"
                        />
                        <Input
                          id="address-line3"                         
                          autoComplete="address-line3"
                          value={formData.AddressLine3}
                          aria-disabled={!isAddressEditable}
                          readOnly={!isAddressEditable}
                          className={
                            !isAddressEditable ? "address-input-readonly" : ""
                          }
                          onChange={(e: any) =>
                            handleInputChange("AddressLine3", e.target.value)
                          }
                        />                        
                      </div>
                    </Col>
                    <Col span={24}>
                      <label
                        id="address-city-label"
                        tabIndex={0}
                        role="article"
                        aria-label="address-city-label"
                        htmlFor="address-city"
                        style={styles.addressHeader}
                        className="city-label"
                      >
                        {t("PROFILE_PAGE.CITY")}
                        <span
                          className="required-asterisk"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only"> required</span>
                      </label>
                      <div className="field-with-icon">
                        <Building
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          id="build1-icon"
                          role="img"
                          aria-label="address-city-icon"
                          tabIndex={0}
                          aria-hidden="false"
                        />
                        <Input
                          id="address-city"
                          aria-describedby="address-city-value"
                          autoComplete="address-level2"
                          aria-required="true"
                          value={formData.AddressCity}
                          aria-disabled={!isAddressEditable}
                          readOnly={!isAddressEditable}
                          className={
                            !isAddressEditable ? "address-input-readonly" : ""
                          }
                          // disabled={!isAddressEditable}
                          onChange={(e: any) =>
                            handleInputChange("AddressCity", e.target.value)
                          }
                        />
                        <span
                          id="address-city-value"
                          className="sr-only"
                        >{formData.AddressCity}</span>
                      </div>
                    </Col>
                    <Col span={24}>
                      <label
                        id="address-state-label"
                        tabIndex={0}
                        role="article"
                        aria-label="address-state-label"
                        htmlFor="address-state"
                        style={styles.addressHeader}
                        className="state-label"
                      >
                        {t("PROFILE_PAGE.STATE")}
                        <span
                          className="required-asterisk"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only"> required</span>
                      </label>
                      <div className="field-with-icon">
                        <Flag
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          id="flag-icon"
                          role="img"
                          aria-label="address-state-icon"
                          tabIndex={0}
                          aria-hidden="false"
                        />
                        <Select
                          id="address-state"
                          tabIndex={0}
                          style={{ width: "100%", height: "40px" }}
                          value={formData.AddressState || undefined}
                          aria-disabled={!isAddressEditable}
                          open={isAddressEditable ? undefined : false}
                          className={`address-state-select ${
                            !isAddressEditable ? "address-input-readonly" : ""
                          }`}
                          options={US_STATES}
                          showSearch={isAddressEditable}
                          onKeyDown={(e) => {
                            if (!isAddressEditable && e.key !== "Tab") {
                              e.preventDefault();
                            }
                          }}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          aria-describedby="address-state-selected-value"
                          onChange={(value: string) =>
                            isAddressEditable &&
                            handleInputChange("AddressState", value)
                          }
                          onDropdownVisibleChange={setStateDropdownOpen}
                        />
                        <span
                          id="address-state-selected-value"
                          className="sr-only"
                        >
                          {formData.AddressState
                            ? getSelectedStateLabel(formData.AddressState)
                            : ""}
                        </span>
                        {!stateDropdownOpen && (
                          <div
                            id="address-state_list"
                            role="listbox"
                            aria-hidden="true"
                            style={{ display: "none" }}
                          />
                        )}
                      </div>
                    </Col>
                    <Col span={24}>
                      <label
                        id="address-postal-code-label"
                        tabIndex={0}
                        role="article"
                        aria-label="address-postal-code-label"
                        htmlFor="address-postal-code"
                        style={styles.addressHeader}
                      >
                        {t("PROFILE_PAGE.PIN")}
                        <span
                          className="required-asterisk"
                          aria-hidden="true"
                        ></span>
                        <span className="sr-only"> required</span>
                      </label>
                      <div className="field-with-icon">
                        <Mail
                          className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                          size={18}
                          id="mail-icon"
                          role="img"
                          aria-label="address-postal-code-icon"
                          tabIndex={0}
                          aria-hidden="false"
                        />
                        <Input
                          id="address-postal-code"                          
                          autoComplete="postal-code"                          
                         value={
  isAddressEditable
    ? formData.AddressPostalCode
    : formData.AddressPostalCode
      ? formData.AddressPostalCode.split("").join("\u202F")
      : ""
}
                          aria-disabled={!isAddressEditable}
                          readOnly={!isAddressEditable}
                          className={`address-pin-input ${
                            !isAddressEditable ? "address-input-readonly" : ""
                          }`}
                          key={pinResetKey}
                          onChange={(e: any) =>
                            handleInputChange(
                              "AddressPostalCode",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : null}
              <Col span={24}>
                {validationError && (
                  <div ref={alertRef} tabIndex={-1} style={{ outline: "none" }}>
                    <Alert message={validationError} type="error" />
                  </div>
                )}
                {successMessage && (
                  <div
                    ref={successAlertRef}
                    tabIndex={-1}
                    style={{ outline: "none" }}
                  >
                    <Alert message={successMessage} type="success" />
                  </div>
                )}
              </Col>

              <div style={styles.buttonWrapper}>
                {/* {choices == "Other" ? (
                <Button
                  className="btn btn-default btn-outline-secondary mr-3"
                  type="primary"
                  style={styles.buttonClear}
                  onClick={clearForm}
                  data-testid="test-address-clear-btn"
                >
                  {t("PROFILE_PAGE.CLEAR")}
                </Button>
              ) : null} */}
                {!isAddressEditable && (
                  <Button
                    className="btn btn-default btn-outline-secondary mr-3"
                    type="primary"
                    style={styles.buttonClear}
                    onClick={confirm}
                    data-testid="test-address-confirm-btn"
                    id="address-confirm-save-btn"
                  >
                    {t("PROFILE_PAGE.CONFIRM")}
                  </Button>
                )}
                {!isAddressEditable && (
                  <Button
                    className="btn btn-default btn-outline-secondary mr-3"
                    type="primary"
                    style={styles.buttonClear}
                    onClick={() => {
                      setIsAddressEditable(true);
                      setSuccessMessage("");
                    }}
                    data-testid="test-address-update-btn"
                    id="change-address-btn"
                  >
                    {t("PROFILE_PAGE.UPDATE_ADDRESS_BTN")}
                  </Button>
                )}
                {isAddressEditable && (
                  <Button
                    className="btn btn-default btn-outline-secondary mr-3"
                    type="primary"
                    style={styles.buttonSave}
                    onClick={proceedToUpdate}
                    data-testid="test-address-save-btn"
                    id="address-proceed-to-update-btn"
                  >
                    {t("PROFILE_PAGE.PROCEED_TO_UPDATE_BTN")}
                  </Button>
                )}
                {/* <Button
                className="btn-fab1 btn-forward1"
                type="primary"
                style={styles.buttonSave}
                onClick={handleSubmit}
                data-testid="test-address-save-btn"
              >
                {t("PROFILE_PAGE.UPDATE_ADDRESS_BTN")}
              </Button> */}
                <Modal
                  title={t("PROFILE_PAGE.UPDATE_ADDRESS")}
                  open={isModalOpen}
                  onOk={handleModelOk}
                  onCancel={handleCancel}
                  confirmLoading={submitting}
                  maskClosable={!submitting}
                  closable={!submitting}
                  okButtonProps={{
                    style: { backgroundColor: BrandColors.BUTTON_BG },
                  }}
                  cancelButtonProps={{
                    disabled: submitting,
                    style: {
                      color: BrandColors.BUTTON_BG,
                      borderColor: BrandColors.BUTTON_BG,
                    },
                  }}
                >
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: BrandColors.HEADER_BG
                          ? BrandColors.HEADER_BG
                          : "#1677ff",
                        fontFamily: "Montserrat, sans-serif",
                      },
                    }}
                  >
                    <Radio.Group
                      onChange={onChangeModalValue}
                      value={selectedValue}
                    >
                      <Space direction="vertical">
                        <div
                          style={{
                            fontSize: "14px",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: BrandColors.HEADER_BG,
                          }}
                        >
                          {t("PROFILE_PAGE.INPUT_ADDRESS")}
                        </div>
                        <Radio value={"InputAddress"} id="input-address">
                          <div style={styles.subheader}>
                            <div>
                              {validateSyncAddress?.InputAddress.AddressLine1}
                            </div>
                            <div>
                              {validateSyncAddress?.InputAddress.AddressLine2}
                            </div>
                            <div>
                              {validateSyncAddress?.InputAddress.AddressLine3}
                            </div>
                            <div>
                              {validateSyncAddress?.InputAddress.AddressCity}
                            </div>
                            <div>
                              {validateSyncAddress?.InputAddress.AddressState}
                            </div>
                            <div>
                              {
                                validateSyncAddress?.InputAddress
                                  .AddressPostalCode
                              }
                            </div>
                          </div>
                        </Radio>
                        <div
                          style={{
                            fontSize: "14px",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: BrandColors.HEADER_BG,
                          }}
                        >
                          {t("PROFILE_PAGE.CORRECTED_ADDRESS")}
                        </div>
                        <Radio
                          value={`CorrectedAddress`}
                          id="corrected-address"
                        >
                          <div style={styles.subheader}>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressLine1
                              }
                            </div>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressLine2
                              }
                            </div>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressLine3
                              }
                            </div>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressCity
                              }
                            </div>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressState
                              }
                            </div>
                            <div>
                              {
                                validateSyncAddress?.CorrectedAddress
                                  .AddressPostalCode
                              }
                            </div>
                          </div>
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </ConfigProvider>
                  {modalValidationError && (
                    <Alert message={modalValidationError} type="error" />
                  )}
                </Modal>
              </div>
            </div>
          ) : (
            <>
              <div style={styles.header}>
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: BrandColors.HEADER_BG
                        ? BrandColors.HEADER_BG
                        : "#1677ff",
                      fontFamily: "Montserrat, sans-serif",
                      colorText: token.colorTextSecondary
                        ? token.colorTextSecondary
                        : "#1677ff",
                    },
                  }}
                >
                  {showAdditionalAddresses &&
                    additionalAddresses.map((address, index) => (
                      <Radio
                        key={index}
                        value={`AdditionalAddress${index + 1}`}
                        id="additional-addresses"
                      >
                        <div style={styles.subheader}>
                          <div>
                            {address.AddressLine1}
                            {address.AddressLine2}
                            {address.AddressLine3}
                          </div>
                          <div>{address.AddressCity}</div>
                          <div>
                            {address.AddressState}
                            {address.AddressPostalCode}
                          </div>
                        </div>
                      </Radio>
                    ))}
                </ConfigProvider>
                {choices == "Other" &&
                showFailureMessage !== "Updated Successfully" ? (
                  <div
                    style={styles.formSec}
                    className="address-form-section address-form-stacked"
                  >
                    <Row gutter={[16, 4]}>
                      <Col span={24}>
                        <label
                          id="address-line1-success-label"
                          tabIndex={0}
                          htmlFor="address-line1-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.ADDRESS_LINE_1")}
                          <span
                            className="required-asterisk"
                            aria-hidden="true"
                          ></span>
                          <span className="sr-only"> required</span>
                        </label>
                        <div className="field-with-icon">
                          <Home
                            className="field-icon"
                            size={18}
                            id="home1-icon1"
                            aria-label="address-line1-icon1"
                            tabIndex={0}
                          />
                          <Input
                            id="address-line1-success"
                            //aria-label="address-line1-success-label"
                            value={formData.AddressLine1}
                            disabled={!isAddressEditable}
                            onChange={(e: any) =>
                              handleInputChange("AddressLine1", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col span={24}>
                        <label
                          id="address-line2-success-label"
                          tabIndex={0}
                          htmlFor="address-line2-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.ADDRESS_LINE_2")}
                          <span
                            className="required-asterisk"
                            aria-hidden="true"
                          ></span>
                          <span className="sr-only"> required</span>
                        </label>
                        <div className="field-with-icon">
                          <Building2
                            className="field-icon"
                            size={18}
                            id="build2-icon"
                            aria-label="address-line2-icon1"
                            tabIndex={0}
                          />
                          <Input
                            id="address-line2-success"
                            //aria-label="address-line2-success-label"
                            value={formData.AddressLine2}
                            disabled={!isAddressEditable}
                            onChange={(e: any) =>
                              handleInputChange("AddressLine2", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col span={24}>
                        <label
                          id="address-line3-success-label"
                          tabIndex={0}
                          htmlFor="address-line3-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.ADDRESS_LINE_3")}
                        </label>
                        <div className="field-with-icon">
                          <MapPin
                            className="field-icon"
                            size={18}
                            id="map1-icon"
                            aria-label="address-line3-icon1"
                            tabIndex={0}
                          />
                          <Input
                            id="address-line3-success"
                            //aria-label="address-line3-success-label"
                            value={formData.AddressLine3}
                            disabled={!isAddressEditable}
                            onChange={(e: any) =>
                              handleInputChange("AddressLine3", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col span={24}>
                        <label
                          id="address-city-success-label"
                          tabIndex={0}
                          htmlFor="address-city-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.CITY")}
                          <span
                            className="required-asterisk"
                            aria-hidden="true"
                          ></span>
                          <span className="sr-only"> required</span>
                        </label>
                        <div className="field-with-icon">
                          <Building
                            className="field-icon"
                            size={18}
                            id="build3-icon"
                            aria-label="address-city-icon1"
                            tabIndex={0}
                          />
                          <Input
                            id="address-city-success"
                            //aria-label="address-city-success-label"
                            value={formData.AddressCity}
                            disabled={!isAddressEditable}
                            onChange={(e: any) =>
                              handleInputChange("AddressCity", e.target.value)
                            }
                          />
                        </div>
                      </Col>
                      <Col span={24}>
                        <label
                          id="address-state-success-label"
                          tabIndex={0}
                          htmlFor="address-state-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.STATE")}
                          <span
                            className="required-asterisk"
                            aria-hidden="true"
                          ></span>
                          <span className="sr-only"> required</span>
                        </label>
                        <div className="field-with-icon">
                          <Flag
                            className={`field-icon ${!isAddressEditable ? "field-icon-disabled" : ""}`}
                            size={18}
                            id="flag1-icon"
                            aria-label="address-state-icon1"
                            tabIndex={0}
                          />
                          <Select
                            id="address-state-success"
                            style={{ width: "100%", height: "40px" }}
                            value={formData.AddressState || undefined}
                            aria-disabled={!isAddressEditable}
                            open={isAddressEditable ? undefined : false}
                            className={
                              !isAddressEditable ? "address-input-readonly" : ""
                            }
                            options={US_STATES}
                            showSearch={isAddressEditable}
                            optionFilterProp="label"
                            aria-describedby="address-state-success-selected-value"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onKeyDown={(e) => {
                              if (!isAddressEditable) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(value: string) =>
                              isAddressEditable &&
                              handleInputChange("AddressState", value)
                            }
                            onDropdownVisibleChange={
                              setStateSuccessDropdownOpen
                            }
                          />
                          <span
                            id="address-state-success-selected-value"
                            className="sr-only"
                          >
                            {formData.AddressState
                              ? getSelectedStateLabel(formData.AddressState)
                              : ""}
                          </span>
                          {!stateSuccessDropdownOpen && (
                            <div
                              id="address-state-success_list"
                              role="listbox"
                              aria-hidden="true"
                              style={{ display: "none" }}
                            />
                          )}
                        </div>
                      </Col>
                      <Col span={24}>
                        <label
                          id="address-postal-code-success-label"
                          tabIndex={0}
                          htmlFor="address-postal-code-success"
                          style={styles.addressHeader}
                        >
                          {t("PROFILE_PAGE.PIN")}
                          <span
                            className="required-asterisk"
                            aria-hidden="true"
                          ></span>
                          <span className="sr-only"> required</span>
                        </label>
                        <div className="field-with-icon">
                          <Mail
                            className="field-icon"
                            size={18}
                            id="mail2-icon"
                            aria-label="address-postal-code-icon1"
                            tabIndex={0}
                          />
                          <Input
                            id="address-postal-code-success"
                            //aria-label="address-postal-code-success-label"
                            value={formData.AddressPostalCode}
                            disabled={!isAddressEditable}
                            onChange={(e: any) =>
                              handleInputChange(
                                "AddressPostalCode",
                                e.target.value,
                              )
                            }
                            key={pinResetKey}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : null}
                <Col span={24}>
                  {validationError && (
                    <Alert
                      ref={alertRef}
                      tabIndex={-1}
                      message={validationError}
                      type="error"
                    />
                  )}
                  {successMessage && (
                    <Alert
                      ref={successAlertRef}
                      tabIndex={-1}
                      message={successMessage}
                      type="success"
                    />
                  )}
                </Col>
                <div style={styles.buttonWrapper}>
                  {!isAddressEditable && (
                    <Button
                      className="btn btn-default btn-outline-secondary mr-3"
                      type="primary"
                      style={styles.buttonClear}
                      onClick={confirm}
                      data-testid="test-address-confirm-btn"
                      id="address-confirm-save-btn"
                    >
                      {t("PROFILE_PAGE.CONFIRM")}
                    </Button>
                  )}
                  {!isAddressEditable && (
                    <Button
                      className="btn btn-default btn-outline-secondary mr-3"
                      type="primary"
                      style={styles.buttonClear}
                      onClick={() => {
                        setIsAddressEditable(true);
                        setSuccessMessage("");
                      }}
                      data-testid="test-address-update-btn"
                      id="change-address-btn"
                    >
                      {t("PROFILE_PAGE.UPDATE_ADDRESS_BTN")}
                    </Button>
                  )}
                  {isAddressEditable && (
                    <Button
                      className="btn btn-default btn-outline-secondary mr-3"
                      type="primary"
                      style={styles.buttonSave}
                      onClick={proceedToUpdate}
                      data-testid="test-address-save-btn"
                      id="address-proceed-to-update-btn"
                    >
                      {t("PROFILE_PAGE.PROCEED_TO_UPDATE_BTN")}
                    </Button>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Spin>
    </section>
  );
};
export default AddressVerification;
